import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, Card, IconButton, Tooltip } from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import {Settings, VisibilityRounded, BackspaceTwoTone} from '@material-ui/icons';
import DatasheetView from './DatasheetView';
import DatePicker from './DatePicker';
// import moment from 'moment';
// import Toggle from './Toggle';
import DropDown from './DropDown';
import InputField from './InputField';
import TextAreaField from './TextAreaField';
import AlertDialog from './AlertDialogue';
// import OHSFormLink from './OHSFormLink';
// import OHSQualSubform from './OHSQualSubform';
// import { activeGridFilterItemsSelector } from '@material-ui/data-grid';

export default class OHSInjuries extends Component {

    constructor(props) {
        super(props);
        this.initial_state = {
            error: false,
            error_message: '',
            file_warning: '',
            page_state: 'init',
            page_sub_state: 'init',
            active_branches_array: [],
            injuries_array: [],
            branch_users_array: [],
            selected_branch: '',
            selected_branch_description: '',
            selected_injured_employee: null,
            selected_reporting_employee: null,
            selectedFile: null,
            show_dialogue: false,
            dialogue_object: {},
            form_data: {},
            qual_link: '',
            qual_obj: {id:0},
            writing: false,
            edits_made: false,
            current_record: {},
            primary_button_text: 'Create Injury Report'
        }
        this.state = this.initial_state;

        this.datasheetFieldSpecs_active = [
            { field: 'incident_date', headerName: 'Incident Date', width: 130},
            { field: 'injured_employee_name', headerName: 'Injured Employee', width: 170},
            { field: 'injured_employee_id', headerName: 'ID Number', width: 120, sortable: false},
            { field: 'category_of_injury', headerName: 'Category', width: 120},
            { field: 'nature_of_injury', headerName: 'Nature of Inujury', width: 160, sortable: false},
            { field: 'days_of_duty', headerName: 'Days of Duty', width: 75, align:'center', sortable: false},
            { field: 'view_details', headerName: 'Description', width: 80, align:'center', sortable:false,
            renderCell: (parms) => (
                <IconButton
                    onClick={()=>this.viewDesc(parms.row)} 
                >
                    <Tooltip title="View Incident Description">
                        <VisibilityRounded/>
                    </Tooltip>
                </IconButton>
            )},
            { field: 'case_ref', headerName: 'Case #', width: 110},
            { field: 'reporting_employee_name', headerName: 'Reported by', width: 160},
            { field: 'reporting_employee_id', headerName: 'ID Number', width: 120, sortable: false},
            { field: 'created', headerName: 'Report Filed', width: 130},
        ]

        this.datasheetFieldSpecs2 = [
            { field: 'select', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.selectInjEmpl(parms)} 
                    color='primary'
                    variant='outlined'
                    // disabled={!this.state.search_ready}
                >
                    Select
                </Button>
            )},
            { field: 'id', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},     
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'id_number', headerName: 'ID Number', width: 130},
            { field: 'store_code', headerName: 'Branch', width: 80, sortable:false},
            { field: 'region', headerName: 'Region', width: 80, sortable:false},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125,sortable: false}

        ]

        this.datasheetFieldSpecs3 = [
            { field: 'select', headerName: ' ', width: 120, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <Button 
                    onClick={()=>this.selectRepEmpl(parms)} 
                    color='primary'
                    variant='outlined'
                    // disabled={!this.state.search_ready}
                >
                    Select
                </Button>
            )},
            { field: 'id', headerName: 'Empl.#', width: 110, align:'center',headerAlign:'center'},     
            { field: 'name', headerName: 'Employee', width: 180},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'date_of_entry', headerName: 'DOE', width: 120},
            { field: 'id_number', headerName: 'ID Number', width: 130},
            { field: 'store_code', headerName: 'Branch', width: 80, sortable:false},
            { field: 'region', headerName: 'Region', width: 80, sortable:false},
            { field: 'reports_to_rom', headerName: 'Manager Code', align: 'center',width: 125,sortable: false}

        ]

        this.input_fieldSpecs = [
            {field: "category_of_injury", headerName: "Injury Category", f_inputType:'dropdown', f_show:true, f_required:true},
            {field: "incident_date", headerName: "Incident Date", f_inputType:'datepicker', f_show:true, f_required:true},
            {field: "days_of_duty", headerName: "Days of Duty", f_inputType:'number', f_show:true, f_required:true,  f_maxLength: 5},
            {field: "case_ref", headerName: "Case Ref#", f_inputType:'text', f_show:true, f_required:false,  f_maxLength: 25},
            {field: "nature_of_injury", headerName: "Nature of Injury", f_inputType:'text', f_show:true, f_required:true,  f_maxLength: 30},
            {field: "incident_description", headerName: "Brief Description of Incident", f_inputType:'text', f_show:true, f_required:true, f_minLength:20, f_maxLength: 800},
        ]
    }

    resolveBranchName = (store_code) => {
        return this.state.active_branches_array.find(branch => {
            return branch.store_code === store_code;
        }).branch
    }

     componentDidMount = () => {
        if (!this.state.active_branches_array.length) {
            Gserv.sendCommand('query_active_branches',this.props.gwt)
            .then(reply=>{
                // console.log('query_active_branches reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (query_active_branches) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                    console.log('error on return from Gserv (query_active_branches) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({active_branches_array:reply.Records,page_state:'ready'});
                }
            });
        }
    };
    
    resetMe = () => {
        let reset_state = this.initial_state;
        delete reset_state.active_branches_array; //Don't reset active_branches_array
        reset_state.page_state = 'ready';
        this.setState(reset_state);
    }
   
    cancelCreate = () => {
        let reset_state = this.initial_state;
        delete reset_state.active_branches_array; //Don't reset active_branches_array
        delete reset_state.selected_branch; //Don't reset selected branch
        delete reset_state.selected_branch_description //Don't reset selected branch
        delete reset_state.branch_users_array // Don't reset branch users array
        delete reset_state.injuries_array // Don't clear injury reports for branch
        reset_state.page_state = 'branch view';
        this.setState(reset_state);
    }

    viewDesc = (parms) => {
        // console.log('parms :>> ', parms);
        this.setState({show_dialogue:true, dialogue_object: parms})
    }
    
    dialogCallBack = () => {
        this.setState({show_dialogue:false, dialogue_object: {}});
    }

    handleBranchSelect = (e) => {
        // console.log('e :>> ', e);
        if (e.value !== ''){
            this.setState({selected_branch:e.value, selected_branch_description: this.resolveBranchName(e.value)});
        } else {
            this.setState({selected_branch:'', selected_branch_description: ''});
        }
    }

    fetchOHSData = () => {

        if (this.state.selected_branch==='') {return}

        this.setState({page_state:'fetching branch data'});

        //async fetch branch ohs data...
        Gserv.sendCommand('query_injury_reports_for_branch',this.props.gwt,{selected_branch : this.state.selected_branch})
        .then(ohs_data => {
            // console.log('query_injury_reports_for_branch reply :>> ', ohs_data);
            if (ohs_data.error){
                console.log('error on return from Gserv (query_injury_reports_for_branch) :>> ', ohs_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (ohs_data.Result!=="Success"){
                console.log('error on return from Gserv (query_injury_reports_for_branch) :>> ', ohs_data);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {

                this.setState({
                    injuries_array: ohs_data.injury_reports,
                    page_state:'branch view'
                });
            }
        });
        
        // async query branch employees...
        Gserv.sendCommand('query_branch_employees',this.props.gwt,{selected_branch: this.state.selected_branch})
        .then(reply=>{
            // console.log('query_branch_employees reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_branch_employees) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_branch_employees) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState({branch_users_array:reply.Records});
            }
        });

    }

    selectInjEmpl = (employee) => {
        this.setState({selected_injured_employee:employee.row, edits_made: this.selectionChanged('injured',employee.row)})
    }
  
    selectRepEmpl = (employee) => {
        this.setState({selected_reporting_employee:employee.row, edits_made: this.selectionChanged('reporting',employee.row)})
    }

    handleFieldUpdate = (fieldObj) => {
        // console.log('called field update...');
        // console.log('child field update:',fieldObj);
        // console.log(this.state.current_record);
        // console.log('this.state.form_data :>> ', this.state.form_data);

        let change_flag = this.state.edits_made;

        if (!change_flag){
            switch (fieldObj.field) {
                case 'incident_date':
                    if (this.state.current_record.incident_date !== fieldObj.value) {change_flag=true}
                break;
                
                case 'days_of_duty' :
                    if (this.state.current_record.days_of_duty !== fieldObj.value) {change_flag=true}
                break;

                case 'case_ref':
                    if (this.state.current_record.case_ref !== fieldObj.value) {change_flag=true}
                break;

                case 'nature_of_injury':
                    if (this.state.current_record.nature_of_injury !== fieldObj.value) {change_flag=true}
                break;

                case 'category_of_injury':
                    if (this.state.current_record.category_of_injury !== fieldObj.value) {change_flag=true}
                break;

                case 'incident_description':
                    if (this.state.current_record.incident_description !== fieldObj.value) {change_flag=true}
                break;

                default:
                break;
            }
        }

        // eslint-disable-next-line eqeqeq
        if (fieldObj.value==''){fieldObj.value=null}
        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;
        this.setState({form_data:myFormData, edits_made:change_flag});
    }

    selectionChanged = (type,selection) => {

        if (!this.state.edits_made){
            switch (type) {
                case 'injured':
                    if (selection.id !== this.state.current_record.injured_employee_number) {return true}
                    if (selection.name !== this.state.current_record.injured_employee_name) {return true}
                    if (selection.id_number !== this.state.current_record.injured_employee_id) {return true}
                break;

                case 'reporting':
                    if (selection.id !== this.state.current_record.reporting_employee_number) {return true}
                    if (selection.name !== this.state.current_record.reporting_employee_name) {return true}
                    if (selection.id_number !== this.state.current_record.reporting_employee_id) {return true}
                break;

                default:
                    break;
            }
            return false;
        } else {
            return true;
        }

    }

    submitMe = (e) => {
        e.preventDefault();
        this.setState({writing:true});

        const payload = {
            store_code : this.state.selected_branch,
            injured_employee : this.state.selected_injured_employee,
            reporting_employee : this.state.selected_reporting_employee,
            report_data : this.state.form_data
        }

        //Add injured employee's current rom
        payload.report_data.injured_employees_rom_at_time = this.state.selected_injured_employee.reports_to_rom;

        if (this.state.primary_button_text==='Create Injury Report'){

            Gserv.sendForm('create_ohs_injury_report',this.props.gwt,payload)
            .then(reply=>{
                // console.log('reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (create_ohs_injury_report) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else if (reply.Result==='Failed' && reply.Message.toString().includes('status code 409')){
                    this.setState({error:true,error_message:"This appears to be a duplicate report. Please either delete the existing report, or amend this report.",writing:false});
                } else if (reply.Result==='Failed' && reply.Message.response.data.Message.includes('rom not found')){
                    this.setState({error:true,error_message:"The branch manager code for the selected employee could not be found. Please either correct the branch manager assignment or designation for the injured employee, or amend this report.",writing:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (create_ohs_injury_report) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else {

                    this.setState({
                        page_state: 'fetching branch data',
                        page_sub_state: 'init',
                        form_data: {},
                        selected_injured_employee: null,
                        selected_reporting_employee: null,
                        writing: false
                    });
                    
                    //async fetch branch ohs data...
                    Gserv.sendCommand('query_injury_reports_for_branch',this.props.gwt,{selected_branch : this.state.selected_branch})
                    .then(ohs_data => {
                        // console.log('query_injury_reports_for_branch reply :>> ', ohs_data);
                        if (ohs_data.error){
                            console.log('error on return from Gserv (query_injury_reports_for_branch) :>> ', ohs_data);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else if (ohs_data.Result!=="Success"){
                            console.log('error on return from Gserv (query_injury_reports_for_branch) :>> ', ohs_data);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else {

                            this.setState({
                                injuries_array: ohs_data.injury_reports,
                                page_state:'branch view'
                            });
                        }
                    });
                    
                }
            });

        } else if (this.state.primary_button_text==='Update Injury Report') {
            
            payload.incident_id = this.state.current_record.id;

            Gserv.sendForm('update_ohs_injury_report',this.props.gwt,payload)
            .then(reply=>{
                // console.log('reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (update_ohs_injury_report) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else if (reply.Result==='Failed' && reply.Message.toString().includes('status code 409')){
                    this.setState({error:true,error_message:"This appears to be a duplicate report. Please either delete the existing report, or amend this report.",writing:false});
                } else if (reply.Result==='Failed' && reply.Message.response.data.Message.includes('rom not found')){
                    this.setState({error:true,error_message:"The branch manager code for the selected employee could not be found. Please either correct the branch manager assignment or designation for the injured employee, or amend this report.",writing:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (update_ohs_injury_report) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else {

                    this.setState({
                        page_state: 'fetching branch data',
                        page_sub_state: 'init',
                        form_data: {},
                        selected_injured_employee: null,
                        selected_reporting_employee: null,
                        writing: false
                    });
                    
                    //async fetch branch ohs data...
                    Gserv.sendCommand('query_injury_reports_for_branch',this.props.gwt,{selected_branch : this.state.selected_branch})
                    .then(ohs_data => {
                        // console.log('query_injury_reports_for_branch reply :>> ', ohs_data);
                        if (ohs_data.error){
                            console.log('error on return from Gserv (query_injury_reports_for_branch) :>> ', ohs_data);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else if (ohs_data.Result!=="Success"){
                            console.log('error on return from Gserv (query_injury_reports_for_branch) :>> ', ohs_data);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else {
                            this.setState({
                                injuries_array: ohs_data.injury_reports,
                                page_state:'branch view'
                            });
                        }
                    });
                    
                }
            });
        }
            
    }

    handleUpdate = (record) => {
        // console.log('record.row :>> ', record.row);
        this.setState({
            selected_injured_employee : {
                id: record.row.injured_employee_number,
                name: record.row.injured_employee_name,
                id_number: record.row.injured_employee_id,
                reports_to_rom: record.row.injured_employees_rom_at_time
            },
            selected_reporting_employee : {
                id: record.row.reporting_employee_number,
                name: record.row.reporting_employee_name,
                id_number: record.row.reporting_employee_id
            },
            current_record:record.row,
            page_sub_state:'main form',
            primary_button_text:'Update Injury Report',
            edits_made: false
        });
    }

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);
        // this.setState({show_dialogue:true});

        if (!this.props.super_admin){
            window.alert("Only authorised super administrators are able to delete OHS injury reports.");
            return;
        }

        if (window.confirm("This function will delete this injury report in its entirey - this cannot be undone. Are you sure you wish to proceed?")){

            this.setState({deleting:true,querying:true});
            Gserv.sendCommand('delete_ohs_injury',this.props.gwt,{
                incident_id: record.id
            })
            .then(reply => {
                // console.log('delete reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (delete_ohs_injury) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (delete_ohs_injury) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {

                    this.setState({
                        page_state: 'fetching branch data',
                        page_sub_state: 'init',
                        form_data: {},
                        selected_injured_employee: null,
                        selected_reporting_employee: null,
                        writing: false
                    });
                    
                    //async fetch branch ohs data...
                    Gserv.sendCommand('query_injury_reports_for_branch',this.props.gwt,{selected_branch : this.state.selected_branch})
                    .then(ohs_data => {
                        // console.log('query_injury_reports_for_branch reply :>> ', ohs_data);
                        if (ohs_data.error){
                            console.log('error on return from Gserv (query_injury_reports_for_branch) :>> ', ohs_data);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else if (ohs_data.Result!=="Success"){
                            console.log('error on return from Gserv (query_injury_reports_for_branch) :>> ', ohs_data);
                            this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                        } else {
                            this.setState({
                                injuries_array: ohs_data.injury_reports,
                                page_state:'branch view'
                            });
                        }
                    });

                }
            });
        }
    }

    render() {return(
        <Grid
            container
            direction='column'
        >
            {this.state.show_dialogue&&  
            <AlertDialog
                title={'Description of Injury'}
                description={'Injury to <b>' + this.state.dialogue_object.injured_employee_name + '</b> (ID' + this.state.dialogue_object.injured_employee_id + ') on ' + this.state.dialogue_object.incident_date + '<br/><br/>' + this.state.dialogue_object.incident_description}
                buttons={['CLOSE']}
                callBack={this.dialogCallBack}
            />}

            <Grid item>
                {(this.state.page_state==='init'||this.state.page_state==='ready') &&
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1025
                    }}
                >
                    <Typography color='primary' style={{paddingTop:'15px', paddingBottom: '10px'}}>
                        Injuries on Duty
                    </Typography>

                    <Card
                        elevation={2}
                        style={{marginTop:'0px'}}
                    >
                        <Grid 
                            container 
                            direction='row'
                            justifyContent='center'
                            alignItems='center'
                            style={{padding:'10px', paddingLeft:'50px',marginBottom:15}}
                        >

                            {this.state.page_state==='init'&&!this.state.error&&
                            <div style={{color:'lightgray',marginTop:15}}>
                                <Settings className='icn-spinner' /> <small><i>loading...</i></small>
                            </div>}

                            {this.state.page_state==='ready'&&
                            <DropDown 
                                fieldMap={{
                                    field: "selected_branch",
                                    headerName: "Select Branch",f_inputType:'dropdown',
                                    f_show:true,
                                    f_required:true
                                }}
                                setField={this.handleBranchSelect}
                                // editRecord={this.state.filters}
                                listArray={this.state.active_branches_array}
                                disabled={this.state.page_state !== 'ready'}
                            />}

                        </Grid>
                    </Card>

                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        style={{marginLeft:'10px',marginTop:'15px',marginBottom:'15px'}}
                        disabled={(this.state.selected_branch==='')}
                        onClick={this.fetchOHSData}
                    >
                        Maintain Injury Reports for this branch
                    </Button>

                </Paper>}

                {this.state.page_state==='fetching branch data'&&!this.state.error&&
                <div>
                    <Settings className='icn-spinner' /> Querying Injury Reports for Branch: <b>{this.state.selected_branch}</b> 
                </div>}

                {this.state.page_state==='branch view'&&!this.state.error&&
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        width:1025
                    }}
                >
                    <Paper
                        elevation={3}
                        style={{
                            width:'100%',
                            paddingTop: 15,
                            // paddingBottom: 15,
                            marginBottom: 2
                        }}
                    >
                        {this.state.page_sub_state==='init'&&
                        <Grid>
                            <Button
                                variant='contained'
                                color='primary'
                                // type='submit'
                                style={{marginLeft:'10px',marginTop:'15px',marginBottom:'15px'}}
                                disabled={(!this.state.branch_users_array.length)}
                                onClick={() => this.setState({page_sub_state:'main form', primary_button_text: 'Create Injury Report'})}
                            >
                                Log new injury report
                            </Button>
                            
                            <Button
                                variant='outlined'
                                color='primary'
                                // type='submit'
                                style={{marginLeft:'10px',marginTop:'15px',marginBottom:'15px'}}
                                disabled={(!this.state.branch_users_array.length)}
                                onClick={this.resetMe}
                            >
                                Select Another Branch
                            </Button>
                        </Grid>}

                        {this.state.page_sub_state!=='init'&&
                        <Card
                            elevation={2}
                            style={{padding:'10px'}}
                        >
                            <Grid 
                                container 
                                direction='row'
                                justifyContent='center'
                                alignItems='center'
                            >
                                <Grid item xs={2}></Grid>
                                <Grid item xs={8}>
                                    <Typography color='primary'>
                                        Log an injury report for branch: <b>{this.state.selected_branch_description}</b>
                                    </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                    <Button 
                                        variant='outlined'
                                        size='small'
                                        color='primary'
                                        onClick={this.cancelCreate}
                                        disabled={this.state.writing}
                                    >Cancel</Button>
                                </Grid>
                            </Grid>
                            
                        </Card>}
                    </Paper>

                    {this.state.page_sub_state==='init'&&        
                    <div>
                        <Card
                            elevation={2}
                            style={{padding:'10px'}}
                        >
                            <Typography color='primary' style={{paddingTop:'10px'}}>
                                Injury reports for branch: <b>{this.state.selected_branch_description}</b>
                            </Typography>
                        </Card>

                        {this.state.injuries_array.length!==0&&
                        <div>
                            <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Injury Report History</Typography>

                            {/* active apptms datagrid */}
                            <DatasheetView 
                                dataset={this.state.injuries_array}
                                fieldspecs={this.datasheetFieldSpecs_active}
                                delete={true}
                                edit={true}
                                handleDelete={this.handleDelete}
                                handleEdit={this.handleUpdate}
                                // loading={this.state.querying}
                                deleteHeaderName={'Delete Report'}
                                // pagesize={10}
                                // height={500}
                            />
                        </div>}

                        {!this.state.injuries_array.length&&
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>No injury reports have been logged for this branch</Typography>}

                    </div>}

                    {this.state.page_sub_state==='main form'&&
                    <div>

                        <hr/>    
                        <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Which employee <b>suffered an injury</b> while on duty?</Typography>

                        {!this.state.selected_injured_employee&&
                        <DatasheetView 
                            dataset={this.state.branch_users_array}
                            fieldspecs={this.datasheetFieldSpecs2}
                            delete={false}
                            edit={false}
                            handleDelete={null}
                            handleEdit={null}
                            // loading={this.state.searching}
                            deleteHeaderName={'Delete'}
                            height={300}
                        />}

                        {this.state.selected_injured_employee&&    
                        <Grid 
                            container              
                            direction='row'
                            alignContent='center'
                            justifyContent='center'
                        >
                            <Typography style={{padding:'10px'}}>
                                #{this.state.selected_injured_employee.id} <b>{this.state.selected_injured_employee.name}</b>{this.state.selected_injured_employee.job_title? (' (' + this.state.selected_injured_employee.job_title + ')') :  ''} was injured. 
                            </Typography>
                            <IconButton onClick={()=>this.setState({selected_injured_employee:null})} disabled={this.state.writing}><BackspaceTwoTone/></IconButton>
                        </Grid>}

                        {this.state.selected_injured_employee&&
                        <div>

                            <Typography style={{backgroundColor:'lightgray',padding:'10px'}}>Which employee <b>reported the incident</b>?</Typography>

                            {!this.state.selected_reporting_employee&&
                            <div>
                                <Button 
                                    onClick={()=>this.setState({selected_reporting_employee:{branch_manager:this.state.selected_injured_employee.reports_to_rom}})} 
                                    color='primary'
                                    variant='outlined'
                                    style={{marginTop:10, marginBottom:10}}
                                    // disabled={!this.state.search_ready}
                                >
                                    Branch Manager / ROM
                                </Button>

                                <Typography>or</Typography>
                                
                                <DatasheetView 
                                    dataset={this.state.branch_users_array}
                                    fieldspecs={this.datasheetFieldSpecs3}
                                    delete={false}
                                    edit={false}
                                    handleDelete={null}
                                    handleEdit={null}
                                    // loading={this.state.searching}
                                    deleteHeaderName={'Delete'}
                                    height={300}
                                />
                            </div>}

                            {this.state.selected_reporting_employee&&    
                            <Grid 
                                container              
                                direction='row'
                                alignContent='center'
                                justifyContent='center'
                            >
                                {!this.state.selected_reporting_employee.branch_manager&&
                                <Typography style={{padding:'10px'}}>
                                    #{this.state.selected_reporting_employee.id} <b>{this.state.selected_reporting_employee.name}</b>{this.state.selected_reporting_employee.job_title? (' (' + this.state.selected_reporting_employee.job_title + ')') :  ''} reported the incident. 
                                </Typography>}

                                {this.state.selected_reporting_employee.branch_manager&&
                                <Typography style={{padding:'10px'}}>
                                    The injured employee's branch manager (<b>{this.state.selected_reporting_employee.branch_manager}</b>) reported the incident. 
                                </Typography>}

                                <IconButton onClick={()=>this.setState({selected_reporting_employee:null})} disabled={this.state.writing}><BackspaceTwoTone/></IconButton>
                            </Grid>}
                        </div>} 

                        {this.state.selected_injured_employee&&this.state.selected_reporting_employee&&            
                        <form onSubmit={this.submitMe}>

                            <Typography style={{backgroundColor:'lightgray',padding:'10px'}}><b>Incident details</b></Typography>

                            <Grid 
                                container              
                                direction='row'
                                alignContent='center'
                                justifyContent='space-evenly'
                            >   

                                <div style={{width:'15%'}}>
                                    <DatePicker fieldMap={this.input_fieldSpecs[1]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                                </div>

                                <div style={{width:'15%'}}>
                                    <InputField fieldMap={this.input_fieldSpecs[2]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                                </div>

                                <div style={{width:'15%'}}>
                                    <InputField fieldMap={this.input_fieldSpecs[3]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                                </div>

                                <div style={{width:'15%'}}>
                                    <InputField fieldMap={this.input_fieldSpecs[4]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                                </div>

                                <div style={{width:'15%'}}>
                                    <DropDown fieldMap={this.input_fieldSpecs[0]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} listArray={[{type:'Minor',value:'Minor'},{type:'Serious',value:'Serious'},{type:'Fatal',value:'Fatal'}]} disabled={this.state.writing} fullwidth={true}/>
                                </div>

                            </Grid>
                            
                            <Grid 
                                container              
                                direction='row'
                                alignContent='center'
                                justifyContent='space-evenly'
                                style={{marginTop:'15px'}}
                            >   
                                <Grid item xs={10} style={{margniTop:15}}>
                                    <TextAreaField fieldMap={this.input_fieldSpecs[5]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                                </Grid>
                            </Grid>
                            
                            <br/>
                            <hr/>   

                            <Button
                                variant='contained'
                                color='primary'
                                type='submit'
                                style={{marginLeft:'10px',marginTop:'15px',marginBottom:'15px'}}
                                disabled={this.state.writing||!this.state.selected_injured_employee||!this.state.selected_reporting_employee||(this.state.primary_button_text==='Update Injury Report'&&!this.state.edits_made)}
                                // onClick={this.submitMe}
                            >
                                {this.state.primary_button_text}
                            </Button>

                        </form>}
                   
                    </div>}

                    {this.state.writing&&!this.state.error&&
                    <Typography style={{padding:5}}>
                        <Settings className='icn-spinner' /> <i>Logging injury report...</i> 
                    </Typography>}

                </Paper>}

            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1200,maxWidth:1200, textAlign:'center',marginBottom:'15px'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    );}
    
}